import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/collaborators/{collaboratorId}']['DELETE'];

const deleteUserWorkflowCollaborator = async ({
  userWorkflowId,
  collaboratorId,
}: ThisApi['params']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.delete(
    `/workflows/user-workflows/${userWorkflowId}/collaborators/${collaboratorId}`,
  );

  return response.data;
};

export default deleteUserWorkflowCollaborator;
